module.exports = __webpack_public_path__ + "assets/img/2.41379d84.png";